module.exports = __webpack_public_path__ + "media/bootstrap-icons/battery-half-95398366.svg";